import UnauthorizedHeader from './UnauthorizedHeader';

export default UnauthorizedHeader;
